import React, { useEffect, useState } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './exclusiveOffer.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { EXCLUSIVE_OFFER_TYPE } from '~/config/constants';
import { fetchHeroApi } from '~/pages/HeroSaga/Hero/heroSlice';
import { fetchGearApi } from '~/pages/ItemSaga/Gear/gearSlice';
import { fetchArtifactApi } from '~/pages/ItemSaga/Artifact/artifactSlice';
import { fetchConsumableApi } from '~/pages/ItemSaga/Consumable/consumableSlice';
import { fetchItemApi } from '~/pages/ItemSaga/Item/itemSlice';

ExclusiveOfferForm.defaultProps = {
    pictureAttributeNames: null,
};
ExclusiveOfferForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function ExclusiveOfferForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const hero = useSelector((state) => state.heroSaga.hero);
    const gear = useSelector((state) => state.itemSaga.gear);
    const artifact = useSelector((state) => state.itemSaga.artifact);
    const consumable = useSelector((state) => state.itemSaga.consumable);
    const item = useSelector((state) => state.itemSaga.item);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchHeroApi(navigate));
        dispatch(fetchGearApi(navigate));
        dispatch(fetchArtifactApi(navigate));
        dispatch(fetchConsumableApi(navigate));
        dispatch(fetchItemApi(navigate));
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(exclusiveOfferMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(hero) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values, setFieldValue } = props;

                                const [receivePool, setReceivePool] = useState([]);

                                const fetchItem = (item) => {
                                    let pool = [];
                                    switch (item) {
                                        case 'rare_hero_offer':
                                            for (let obj of hero.rows) {
                                                if (obj.rarity == 'SSR')
                                                    pool.push(obj);
                                            }
                                            setReceivePool(pool);
                                            break;
                                        case 'normal_hero_offer':
                                            for (let obj of hero.rows) {
                                                if (obj.rarity == 'SR')
                                                    pool.push(obj);
                                            }
                                            setReceivePool(pool);
                                            break;
                                        case 'gear_and_artifact_offer':
                                            setReceivePool(gear.rows.concat(artifact.rows));
                                            break;
                                        case 'consumable_offer':
                                            setReceivePool(consumable.rows);
                                            break;
                                    }
                                }
                                useEffect(() => {
                                    fetchItem(values.offer_type);
                                    let data = [];
                                    if (Array.isArray(values.receive_item_quantity))
                                        data = values.receive_item_quantity;
                                    else
                                        data = values.receive_item_quantity.split(',');
                                    if (values.receive_item_pool.length != data.length) {
                                        data = JSON.parse(JSON.stringify(data));
                                        for (let i = 0; i < data.length - values.receive_item_pool.length; i++) {
                                            data.splice(-1);
                                        }
                                        for (let i = 0; i < values.receive_item_pool.length - data.length; i++) {
                                            data.push(1);
                                        }
                                        setFieldValue('receive_item_quantity', data);
                                    }
                                    if (Array.isArray(values.pay_item_id))
                                        data = values.pay_item_id;
                                    else
                                        data = values.pay_item_id.split(',');
                                    if (values.receive_item_pool.length != data.length) {
                                        data = JSON.parse(JSON.stringify(data));
                                        for (let i = 0; i < data.length - values.receive_item_pool.length; i++) {
                                            data.splice(-1);
                                        }
                                        for (let i = 0; i < values.receive_item_pool.length - data.length; i++) {
                                            data.push(data[0]);
                                        }
                                        setFieldValue('pay_item_id', data);
                                    }
                                    if (Array.isArray(values.pay_item_quantity))
                                        data = values.pay_item_quantity;
                                    else
                                        data = values.pay_item_quantity.split(',');
                                    if (values.receive_item_pool.length != data.length) {
                                        data = JSON.parse(JSON.stringify(data));
                                        for (let i = 0; i < data.length - values.receive_item_pool.length; i++) {
                                            data.splice(-1);
                                        }
                                        for (let i = 0; i < values.receive_item_pool.length - data.length; i++) {
                                            data.push(data[0]);
                                        }
                                        setFieldValue('pay_item_quantity', data);
                                    }
                                }, [values]);

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormSelect
                                                name="offer_type"
                                                options={EXCLUSIVE_OFFER_TYPE}
                                                sm={3}
                                                className="d-flex flex-column justify-content-end"
                                                label="Offer type"
                                            />
                                            <FormText
                                                name={'offer_quantity'}
                                                label="Offer quantity"
                                                className="d-flex flex-column justify-content-end"
                                                sm={3}
                                            />
                                            {pictureAttributeNames.map((imgName, i) => (
                                                <Col
                                                    key={i}
                                                    sm={3}
                                                >
                                                    <FileUploadedWithResetCount
                                                        pictureName={imgName}
                                                        pictureVal={values[imgName]}
                                                        resetCount={resetCount}
                                                        id={imgName}
                                                    />
                                                </Col>
                                            ))}
                                            <div className="col-sm-3"></div>
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name="receive_item_pool"
                                                options={receivePool}
                                                sm={6}
                                                label="Receive item pool"
                                            />
                                            <FormText
                                                name={'receive_item_quantity'}
                                                label="Receive item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <Selectize
                                                name={'pay_item_id'}
                                                options={item.rows}
                                                label="Pay item id"
                                                sm={6}
                                            />
                                            <FormText
                                                name={'pay_item_quantity'}
                                                label="Pay item quantity"
                                                sm={6}
                                            />
                                        </Form.Row>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default ExclusiveOfferForm;
